import { Button, Col, Row, Space } from 'components/common'

export const DiscountButton = (props) => {
  return (
    <>
      <div>
        <Row>
          <Space>
            <Col span={18}>
              <Button>{props.leftButton}</Button>
            </Col>

            <Button type="primary">{props.rightButton}</Button>
          </Space>
        </Row>
      </div>
    </>
  )
}
